import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

// ---------------------------------------------------------------------------
// Sanitized projection of a CrmConnection for client consumption.
// Excludes encrypted token material — only metadata the UI needs to render
// the "Connected accounts" list and disconnect buttons.
// ---------------------------------------------------------------------------

@Entity()
export class CrmConnectionView extends AdornisEntity {
  static override _class = 'CrmConnectionView';

  @Field(type => String) _id!: string;
  @Field(type => String) provider!: string;
  @Field(type => String) accountId?: string;
  @Field(type => String) accountLabel?: string;
  @Field(type => String) authMode?: string;
  @Field(type => Boolean) isSystem!: boolean;
  @Field(type => String) status!: string;
  @Field(type => String) scopes?: string;
  @Field(type => String) connectedAt!: string;
  @Field(type => String) lastUsedAt?: string;
  @Field(type => String) lastError?: string;
}
